import React, {Component} from 'react';
import {connect} from 'react-redux';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const CREATE_TITLE_TEXT = 'Opret';
const UPDATE_TITLE_TEXT = 'Gem';
const DEFAULT_CLASS = 'btn btn-primary clickable';

class SuplierComptenciesSubmit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: CREATE_TITLE_TEXT
        };
    }

    componentDidMount() {
        if (this.props.isUpdate) {
            this.setState({title: UPDATE_TITLE_TEXT})
        }
    }

    render() {

        if (this.props.showSubmitButtonSpinner) {
            return (
                <button disabled type="submit" className={`${DEFAULT_CLASS} disabled`}>
                    <i className="fa fa-spin fa-spinner"/>
                    {this.props.intl.formatMessage(messages.updating)}
                </button>
            );
        }

        return (
            <button onClick={this.props.onClick} className={DEFAULT_CLASS} type="submit">{this.state.title}</button>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        showSubmitButtonSpinner: state.showSubmitButtonSpinner,
    };
}

export default injectIntl(connect(mapStateToProps)(SuplierComptenciesSubmit));


// WEBPACK FOOTER //
// ./web/src/components/supplier-competencies/SupplierCompetenciesSubmit.jsx